/**
 * Generate an opaque ID with the given prefix. Format: `<prefix>_<22-char base64url>`.
 * 16 bytes of randomness = 128 bits ≈ collision-resistant for any realistic volume.
 *
 * Uses the Web Crypto API (globalThis.crypto) so the same code works in Node 20+,
 * Bun, Deno, and browsers. Importing 'node:crypto' here would break the web
 * bundle (Vite/Rollup can't polyfill Node built-ins for the browser).
 */
export function generateId(prefix) {
    const bytes = new Uint8Array(16);
    globalThis.crypto.getRandomValues(bytes);
    let bin = '';
    for (let i = 0; i < bytes.length; i += 1)
        bin += String.fromCharCode(bytes[i]);
    const base64url = btoa(bin).replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
    return `${prefix}_${base64url}`;
}
//# sourceMappingURL=ids.js.map